import React from 'react';
import { Form, Icon, Message, Button } from 'semantic-ui-react'
import _find from 'lodash/find';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import queries from '../../../utils/queries'

import EstaSeguro from '../../../components/funcionales/estaseguro'

const ListaCal = ({nameLista, idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name={nameLista} id={nameLista} value={permiteUpdate?argsDocum[nameLista]:idLista[nameLista]?idLista[nameLista]:"Seleccionar..."} onChange={(ev)=>handleChange(ev)}>
        <option>Seleccionar...</option>
        <option>Excelente</option>
        <option>Regular</option>
        <option>Deficiente</option>
      </select>
    </div>
  )
};

class VerEncuesta2 extends React.Component {
  state={
    argsDocum: {
      respuesta1: this.props.list6.length>0?this.props.list6[0].respuesta?this.props.list6[0].respuesta:'Seleccionar...':'',
      respuesta2: this.props.list6.length>1?this.props.list6[1].respuesta?this.props.list6[1].respuesta:'Seleccionar...':'',
      respuesta3: this.props.list6.length>2?this.props.list6[2].respuesta?this.props.list6[2].respuesta:'Seleccionar...':'',
      respuesta4: this.props.list6.length>3?this.props.list6[3].respuesta?this.props.list6[3].respuesta:'Seleccionar...':'',
      respuesta5: this.props.list6.length>4?this.props.list6[4].respuesta?this.props.list6[4].respuesta:'Seleccionar...':'',
      respuesta6: this.props.list6.length>5?this.props.list6[5].respuesta?this.props.list6[5].respuesta:'Seleccionar...':'',
      respuesta7: this.props.list6.length>6?this.props.list6[6].respuesta?this.props.list6[6].respuesta:'Seleccionar...':'',
      respuesta8: this.props.list6.length>7?this.props.list6[7].respuesta?this.props.list6[7].respuesta:'Seleccionar...':'',
      respuesta9: this.props.list6.length>8?this.props.list6[8].respuesta?this.props.list6[8].respuesta:'Seleccionar...':'',
      respuesta10: this.props.list6.length>9?this.props.list6[9].respuesta?this.props.list6[9].respuesta:'Seleccionar...':'',
    },
    numOrdenCompra: this.props.idLista.numOrdenCompra,
    _id: this.props.idLista._id,
    pregunta1: "",
    pregunta2: "",
    pregunta3: "",
    pregunta4: "",
    pregunta5: "",
    pregunta6: "",
    pregunta7: "",
    pregunta8: "",
    pregunta9: "",
    pregunta10: "",
    confirmaAct: false,
    open: false
  }

  handleChange = (ev) => {
    // if (this.props.permiteUpdate){
      this.setState({confirmaAct: false})
      const argsDocum = this.state.argsDocum
      argsDocum[ev.target.name] = ev.target.value
      this.setState({argsDocum});
    // }
  }
  
  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  handleGrabar = async (ev, argsDocum, idOrden, numOrdenCompra, list6)=>{
    document.body.style.cursor = 'wait'
    let numReg=list6.length
    for(let i=0; i<numReg; i++){
      let rta = ''
      let valoracion = 0
      if(i===0){rta = argsDocum.respuesta1!=='Seleccionar...'?argsDocum.respuesta1:''}
      if(i===1){rta = argsDocum.respuesta2!=='Seleccionar...'?argsDocum.respuesta2:''}
      if(i===2){rta = argsDocum.respuesta3!=='Seleccionar...'?argsDocum.respuesta3:''}
      if(i===3){rta = argsDocum.respuesta4!=='Seleccionar...'?argsDocum.respuesta4:''}
      if(i===4){rta = argsDocum.respuesta5!=='Seleccionar...'?argsDocum.respuesta5:''}
      if(i===5){rta = argsDocum.respuesta6!=='Seleccionar...'?argsDocum.respuesta6:''}
      if(i===6){rta = argsDocum.respuesta7!=='Seleccionar...'?argsDocum.respuesta7:''}
      if(i===7){rta = argsDocum.respuesta8!=='Seleccionar...'?argsDocum.respuesta8:''}
      if(i===8){rta = argsDocum.respuesta9!=='Seleccionar...'?argsDocum.respuesta9:''}
      if(i===9){rta = argsDocum.respuesta10!=='Seleccionar...'?argsDocum.respuesta10:''}
      if(rta==="Excelente"){valoracion = 5}
      if(rta==="Regular"){valoracion = 3}
      if(rta==="Deficiente"){valoracion = 1}
      const argsUpd = {
        pregunta: list6[i].pregunta,
        _id: idOrden,
        respuesta: rta,
        valoracion: valoracion,
        tipoAct: 'EditarItemEncuesta'
      }
      const response = await this.props.editCotizacion({
        variables: argsUpd
      });
      const {errors, success} = response.data.editCotizacion;

      if (!success){
        this.setState({errorAdd: errors})
      }else{
        
      }
    } 
    document.body.style.cursor = 'default'
    alert("!! Encuesta registrada !!")
  }

  render(){
    let list6 = []
    if(this.props.list6){list6 = this.props.list6}
    let numReg=this.props.list6.length
    const {argsDocum, confirmaAct, open} = this.state;

    if(numReg>0){
      argsDocum['respuesta1'] = this.state.argsDocum.respuesta1?this.state.argsDocum.respuesta1:this.props.list6[0].respuesta
    }
    if(numReg>1){
      argsDocum['respuesta2'] = this.state.argsDocum.respuesta2?this.state.argsDocum.respuesta2:this.props.list6[1].respuesta
    }
    if(numReg>2){ 
      argsDocum['respuesta3'] = this.state.argsDocum.respuesta3?this.state.argsDocum.respuesta3:this.props.list6[2].respuesta
    }
    if(numReg>3){  
      argsDocum['respuesta4'] = this.state.argsDocum.respuesta4?this.state.argsDocum.respuesta4:this.props.list6[3].respuesta
    }
    if(numReg>4){  
      argsDocum['respuesta5'] = this.state.argsDocum.respuesta5?this.state.argsDocum.respuesta5:this.props.list6[4].respuesta
    }
    if(numReg>5){  
      argsDocum['respuesta6'] = this.state.argsDocum.respuesta6?this.state.argsDocum.respuesta6:this.props.list6[5].respuesta
    }
    if(numReg>6){  
      argsDocum['respuesta7'] = this.state.argsDocum.respuesta7?this.state.argsDocum.respuesta7:this.props.list6[6].respuesta
    }
    if(numReg>7){  
      argsDocum['respuesta8'] = this.state.argsDocum.respuesta8?this.state.argsDocum.respuesta8:this.props.list6[7].respuesta
    }
    if(numReg>8){  
      argsDocum['respuesta9'] = this.state.argsDocum.respuesta9?this.state.argsDocum.respuesta9:this.props.list6[8].respuesta
    }
    if(numReg>9){  
      argsDocum['respuesta10'] = this.state.argsDocum.respuesta10?this.state.argsDocum.respuesta10:this.props.list6[9].respuesta
    }
    let idOrden = this.props.idLista._id
    let numOrdenCompra = this.props.idLista.numOrdenCompra    

    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large hand point down yellow icon"></i>
          Encuesta de valoración de LCM
        </button>
        {/* <label style={{marginLeft: 800, color: 'red', fontSize: 18}}>Valoraciones:  (0)= Deficiente,    (0,5)=Regular,     (1)= Excelente</label> */}
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1">
              <div className="ui two column stackable grid">
                {numReg>0 &&
                  <div className="row container" style={{margin: 0, paddingTop: 0}}>
                    <div className="column" style={{width: '85%'}}>
                      <Form.Field>
                        <label style={this.props.styles.label}>Pregunta 1</label>
                        <Form.Input autoComplete="off" name='pregunta1' id='pregunta1' value={this.props.list6[0].pregunta} placeholder='Pregunta' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'pregunta1'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                      </Form.Field> 
                    </div>
                    <div className="column" style={{width: '15%'}}>  
                      {/* <Form.Field>
                        <label style={this.props.styles.label}>Valoración</label>
                        <input type='number' step="0.5" min="0" max="1" autoComplete="off" name='respuesta1' id='respuesta1' value={argsDocum.respuesta1} placeholder='Valor' onChange={this.handleChange}/>
                      </Form.Field> */}
                      <Form.Field>
                        <label style={this.props.styles.label}>Valoración</label>
                        <ListaCal styles={this.props.styles} nameLista='respuesta1' idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                  </div>
                }
                {numReg>1 &&
                  <div className="row container" style={{margin: 0, paddingTop: 0}}>
                    <div className="column" style={{width: '85%'}}>
                      <Form.Field>
                        <label style={this.props.styles.label}>Pregunta 2</label>
                        <Form.Input autoComplete="off" name='pregunta2' id='pregunta2' value={this.props.list6[1].pregunta} placeholder='Pregunta' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'pregunta2'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                      </Form.Field> 
                    </div>
                    <div className="column" style={{width: '15%'}}>  
                      {/* <Form.Field>
                        <label style={this.props.styles.label}>Valoración</label>
                        <input type='number' step="0.5" min="0" max="1" autoComplete="off" name='respuesta2' id='respuesta2' value={argsDocum.respuesta2} placeholder='Valor' onChange={this.handleChange}/>
                      </Form.Field> */}
                      <Form.Field>
                        <label style={this.props.styles.label}>Valoración</label>
                        <ListaCal styles={this.props.styles} nameLista='respuesta2' idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                  </div>
                }
                {numReg>2 &&
                  <div className="row container" style={{margin: 0, paddingTop: 0}}>
                    <div className="column" style={{width: '85%'}}>
                      <Form.Field>
                        <label style={this.props.styles.label}>Pregunta 3</label>
                        <Form.Input autoComplete="off" name='pregunta3' id='pregunta3' value={this.props.list6[2].pregunta} placeholder='Pregunta' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'pregunta3'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                      </Form.Field> 
                    </div>
                    <div className="column" style={{width: '15%'}}>  
                      {/* <Form.Field>
                        <label style={this.props.styles.label}>Valoración</label>
                        <input type='number' step="0.5" min="0" max="1" autoComplete="off" name='respuesta3' id='respuesta3' value={argsDocum.respuesta3} placeholder='Valor' onChange={this.handleChange}/>
                      </Form.Field> */}
                      <Form.Field>
                        <label style={this.props.styles.label}>Valoración</label>
                        <ListaCal styles={this.props.styles} nameLista='respuesta3' idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                  </div>
                }
                {numReg>3 &&
                  <div className="row container" style={{margin: 0, paddingTop: 0}}>
                    <div className="column" style={{width: '85%'}}>
                      <Form.Field>
                        <label style={this.props.styles.label}>Pregunta 4</label>
                        <Form.Input autoComplete="off" name='pregunta4' id='pregunta4' value={this.props.list6[3].pregunta} placeholder='Pregunta' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'pregunta4'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                      </Form.Field> 
                    </div>
                    <div className="column" style={{width: '15%'}}>  
                      {/* <Form.Field>
                        <label style={this.props.styles.label}>Valoración</label>
                        <input type='number' step="0.5" min="0" max="1" autoComplete="off" name='respuesta4' id='respuesta3' value={argsDocum.respuesta4} placeholder='Valor' onChange={this.handleChange}/>
                      </Form.Field> */}
                      <Form.Field>
                        <label style={this.props.styles.label}>Valoración</label>
                        <ListaCal styles={this.props.styles} nameLista='respuesta4' idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                  </div>
                }
                {numReg>4 &&
                  <div className="row container" style={{margin: 0, paddingTop: 0}}>
                    <div className="column" style={{width: '85%'}}>
                      <Form.Field>
                        <label style={this.props.styles.label}>Pregunta 5</label>
                        <Form.Input autoComplete="off" name='pregunta5' id='pregunta5' value={this.props.list6[4].pregunta} placeholder='Pregunta' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'pregunta5'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                      </Form.Field> 
                    </div>
                    <div className="column" style={{width: '15%'}}>  
                      {/* <Form.Field>
                        <label style={this.props.styles.label}>Valoración</label>
                        <input type='number' step="0.5" min="0" max="1" autoComplete="off" name='respuesta5' id='respuesta5' value={argsDocum.respuesta5} placeholder='Valor' onChange={this.handleChange}/>
                      </Form.Field> */}
                      <Form.Field>
                        <label style={this.props.styles.label}>Valoración</label>
                        <ListaCal styles={this.props.styles} nameLista='respuesta5' idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                  </div>
                }
                {numReg>5 &&
                  <div className="row container" style={{margin: 0, paddingTop: 0}}>
                    <div className="column" style={{width: '85%'}}>
                      <Form.Field>
                        <label style={this.props.styles.label}>Pregunta 6</label>
                        <Form.Input autoComplete="off" name='pregunta6' id='pregunta6' value={this.props.list6[5].pregunta} placeholder='Pregunta' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'pregunta6'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                      </Form.Field> 
                    </div>
                    <div className="column" style={{width: '15%'}}>  
                      {/* <Form.Field>
                        <label style={this.props.styles.label}>Valoración</label>
                        <input type='number' step="0.5" min="0" max="1" autoComplete="off" name='respuesta6' id='respuesta6' value={argsDocum.respuesta6} placeholder='Valor' onChange={this.handleChange}/>
                      </Form.Field> */}
                      <Form.Field>
                        <label style={this.props.styles.label}>Valoración</label>
                        <ListaCal styles={this.props.styles} nameLista='respuesta6' idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                  </div>
                }
                {numReg>6 &&
                  <div className="row container" style={{margin: 0, paddingTop: 0}}>
                    <div className="column" style={{width: '85%'}}>
                      <Form.Field>
                        <label style={this.props.styles.label}>Pregunta 7</label>
                        <Form.Input autoComplete="off" name='pregunta7' id='pregunta7' value={this.props.list6[6].pregunta} placeholder='Pregunta' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'pregunta7'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                      </Form.Field> 
                    </div>
                    <div className="column" style={{width: '15%'}}>  
                      {/* <Form.Field>
                        <label style={this.props.styles.label}>Valoración</label>
                        <input type='number' step="0.5" min="0" max="1" autoComplete="off" name='respuesta7' id='respuesta7' value={argsDocum.respuesta7} placeholder='Valor' onChange={this.handleChange}/>
                      </Form.Field> */}
                      <Form.Field>
                        <label style={this.props.styles.label}>Valoración</label>
                        <ListaCal styles={this.props.styles} nameLista='respuesta7' idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                  </div>
                }
                {numReg>7 &&
                  <div className="row container" style={{margin: 0, paddingTop: 0}}>
                    <div className="column" style={{width: '85%'}}>
                      <Form.Field>
                        <label style={this.props.styles.label}>Pregunta 8</label>
                        <Form.Input autoComplete="off" name='pregunta8' id='pregunta8' value={this.props.list6[7].pregunta} placeholder='Pregunta' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'pregunta8'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                      </Form.Field> 
                    </div>
                    <div className="column" style={{width: '15%'}}>  
                      {/* <Form.Field>
                        <label style={this.props.styles.label}>Valoración</label>
                        <input type='number' step="0.5" min="0" max="1" autoComplete="off" name='respuesta8' id='respuesta8' value={argsDocum.respuesta8} placeholder='Valor' onChange={this.handleChange}/>
                      </Form.Field> */}
                      <Form.Field>
                        <label style={this.props.styles.label}>Valoración</label>
                        <ListaCal styles={this.props.styles} nameLista='respuesta8' idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                  </div>
                }
                {numReg>8 &&
                  <div className="row container" style={{margin: 0, paddingTop: 0}}>
                    <div className="column" style={{width: '85%'}}>
                      <Form.Field>
                        <label style={this.props.styles.label}>Pregunta 9</label>
                        <Form.Input autoComplete="off" name='pregunta9' id='pregunta9' value={this.props.list6[8].pregunta} placeholder='Pregunta' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'pregunta9'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                      </Form.Field> 
                    </div>
                    <div className="column" style={{width: '15%'}}>  
                      {/* <Form.Field>
                        <label style={this.props.styles.label}>Valoración</label>
                        <input type='number' step="0.5" min="0" max="1" autoComplete="off" name='respuesta9' id='respuesta9' value={argsDocum.respuesta9} placeholder='Valor' onChange={this.handleChange}/>
                      </Form.Field> */}
                      <Form.Field>
                        <label style={this.props.styles.label}>Valoración</label>
                        <ListaCal styles={this.props.styles} nameLista='respuesta9' idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                  </div>
                }
                {numReg>9 &&
                  <div className="row container" style={{margin: 0, paddingTop: 0}}>
                    <div className="column" style={{width: '85%'}}>
                      <Form.Field>
                        <label style={this.props.styles.label}>Pregunta 10</label>
                        <Form.Input autoComplete="off" name='pregunta10' id='pregunta10' value={this.props.list6[9].pregunta} placeholder='Pregunta' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'pregunta10'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                      </Form.Field> 
                    </div>
                    <div className="column" style={{width: '15%'}}>  
                      {/* <Form.Field>
                        <label style={this.props.styles.label}>Valoración</label>
                        <input type='number' step="0.5" min="0" max="1" autoComplete="off" name='respuesta10' id='respuesta10' value={argsDocum.respuesta10} placeholder='Valor' onChange={this.handleChange}/>
                      </Form.Field> */}
                      <Form.Field>
                        <label style={this.props.styles.label}>Valoración</label>
                        <ListaCal styles={this.props.styles} nameLista='respuesta10' idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                  </div>
                }
              </div>
              {numReg>0 &&
                <div className="column" style={{width: '100%', paddingTop: '0.8em'}}>
                  <Button id="elim" name="elim" style={{...this.props.styles.confirmar, height: '2.7em'}} onClick={(ev)=>this.handleGrabar(ev, argsDocum, idOrden, numOrdenCompra, list6)} fluid>
                    GRABAR
                  </Button>
                </div>
              }
              {/* <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
              {
                this.props.errors.length?<Message negative header="Los siguientes errores:"
                list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
              } */}
          </Form>
        </div>
      </div>
    )
  }
}
export default compose(
  graphql(queries.query.allProducto, {name:'allProducto'}),
  graphql(queries.query.allEmpresa, {name:'allEmpresa'}),

  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtes00',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Cliente', estado: 'Aprobada'}}]`}}}}),
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtes11',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Cliente', estado: 'Aprobada'}}]`}}}}),

  graphql(queries.mutation.editCotizacion, {name:'editCotizacion'}),


)(VerEncuesta2)
